import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import {Form, Container} from "react-bootstrap";
import ColDynamic from "../EntryForms/WrapperComponents/ColDynamic";
import "../../containers/ControlMeasures/ControlMeasures.css";
//import DatePicker from "../UI/DatePicker/DatePicker";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import InputComponent from "../UI/InputComponent/InputComponent";
import Upload from "../UI/Upload/Upload";
import UploadComponent from "../UI/Upload/UploadComponent";
import Dropdown from "../UI/Dropdown/Dropdown";
import ModalComponent from "../UI/Modal/Modal";
import moment from "moment";
import DatepickerComponent from "../UI/DatePicker/DatepickerComponent";

const controlMeasuresAdd = (props) => {
  let parentState = { ...props };
  let measureOptions = parentState.dropDownData.map((element) => (
    <option key={element.mjeraId} value={element.mjeraId}>
      {element.opisMjere}
    </option>
  ));

  return (
    <>
      <ModalComponent
        size="l"
        show={props.modal}
        onHide={props.hideModal}
        className="heder"
        centered
        title= 
        {props.isMeasureEdit ? 
       ( "Ažuriranje nadzorne mjere") : ("Unos nadzorne mjere") }
      >
  
        <Modal.Body>
          <div className="justify-content-center" key={"form"}>
            <div className="align-self-center modal-mjere">
              <Form onSubmit={props.submitHandler}>
               <div>
          
                <label>Rješenje*</label>
                <div  className="unos_upload upload-modal">
                  <UploadComponent
                   
                    key={"test"}
                    id={"testId"}
                    onChange={props.uploadHandler}
                    fileList={props.formData.selectedFile}
                    style={
                      props.error &&
                      props.formData.selectedFile.length < 1 &&
                      "red"
                    }
                  />
                </div>

                <InputComponent
                  id="solutionNum"
                  value={props.formData.solutionNum}
                  onChange={props.userInputFormHandler}
                  controlLabel={"Broj rješenja*"}
                  className="input-modal"
                  name="brRjesenja"
                  style={props.error && (!props.formData.solutionNum || props.formData.solutionNum.length > 20) && "red" }
                  
                />
                <ColDynamic className="datepicker-modal">
                  <DatepickerComponent
                    required
                    value={props.formData.solutionDat }
                    errorBorderColor={
                      props.error && !props.formData.solutionDat && "red"
                    }
                    id="solutionDat"
                    handleDayClick={props.datePickerHandler}
                    controlLabel={"Datum rješenja"}
                    //selectedDays={props.formData.solutionDat}
                    index={{ id: "solutionDat" }}
                    width={"100%"}
                  />
                </ColDynamic>

                <Dropdown
                  onChange={props.mjereDropDownHandler}
                  value={props.formData.measuretype}
                  label={"Naziv mjere*"}
                  asProperty="select"
                  map={measureOptions}
                  text="Vrsta mjere"
                  className="drop drop-mjere"
                  name="idMjere"
                  id="nazivMjere"
                  style={props.error && !props.formData.measuretype && "red"}
                />
                <ColDynamic className="datepicker-modal">
                  <DatepickerComponent
                    id="downloadDat"
                    handleDayClick={props.datePickerHandler}
                    controlLabel={"Datum pravomoćnosti"}
                    //selectedDays={props.downloadDat}
                    index={{ id: "downloadDat" }}
                    value={props.formData.datPravomocnosti}
                    width={"100%"}
                  />
                </ColDynamic>

                <InputComponent
                  id="note"
                  as="textarea"
                  value={props.formData.note}
                  onChange={props.userInputFormHandler}
                  controlLabel={"Napomena"}
                  className="textarea-modal"
                  name="napomena"
                  maxLength={2000}
                />
                </div>
                
                <div className="row" key={"button"}>
                  <div className="col-md-6">
                    <ButtonComponent
                      type="submit"
                      block={true}
                      variant="primary"
                      disabled={props.loader}
                    > 
                    {props.loader ? 
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      /> 
                      :
                      props.isMeasureEdit && !props.loader ? "Ažuriraj" 
                      :
                      !props.isMeasureEdit && !props.loader ? "Spremi"
                      : 
                      null
                    }
                    </ButtonComponent>
                    
                  </div>
                  <div className="col-md-6">
                    <ButtonComponent
                      onClick={props.hideModal}
                      block={true}
                      variant="danger"
                    >
                      Odustani
                    </ButtonComponent>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </Modal.Body>
      </ModalComponent>
    </>
  );
};

export default controlMeasuresAdd;
